<div class="notification" [ngClass]="'notification--' + notificationType">
    <div class="image"></div>
    <span>{{ notificationString }}</span>
</div>

